import React,{useState} from 'react';
import './App.css';
import './index.css'
import loginIcon from './images/loginIcon.jpg'
import regIcon from './images/regIcon.jpg'
import LoginPage from './LoginPage';
import RegPage from './RegPage';


function App() {

   let [views,reViews]=useState(1);
   let [imgSrc,reImgSrc]=useState(loginIcon);
   let [para,rePara]=useState("");
   let strr="Let's make your Dream Registration Here";

  return (
    <div className='bg-[white]  lg:flex flex-row  p-10 m-[5%] rounded-lg shadow-md'>
      
      <div className='basis-1/2 w-full flex justify-center items-center flex-col md:mb-0 mb-6	'>
        <h1 className='lg:text-4xl font-bold text-center lg:mb-4 mb-2 text-red-500'>
            {para}
          </h1>
          <img src={imgSrc} alt='' className='lg:w-[70%] w-[40%] lg:mb-4 md-3'/>
          <h2 className='lg:text-2xl   text-xl text-[#001ad2] font-semibold'>Welcome to our community</h2>
          <p className='text-gray-600 lg:text-sm text-xs'>
            A whole new productive journey starts right here
          </p>
         
      </div>
      <div className='basis-2/3  w-full lg:ml-5'>

      <div className='md:text-right text-center md:mb-1 m-8 lg:text-sm text-xs'>
        
          {(() => {
            
            if(views===1)
            {
          return (
            <>
            Don't have an account yet ? <a href='/'  onClick={(e:any)=>{
              e.preventDefault()
              reViews(2)
              reImgSrc(regIcon)
              rePara(strr)
            }} className='text-[#001ad2] font-bold'>Sign Up Here</a>
            <LoginPage/>
           </>
          )
            } 
            else{
              return (
                <>
                 Already a user ? <a href='/' onClick={(e:any)=>{
                     e.preventDefault()
              reViews(1)
              reImgSrc(loginIcon)
              rePara("")
            }} className='text-[#001ad2] font-bold'>Login Here</a>
                 <RegPage/>
                </>
              )
            }

          })()}
        
       
      </div>

    

      </div>
    </div>
  );
}

export default App;
